<template>
  <a
    :href="url"
    target="_blank"
    @mouseover="hover(url)"
    @mouseleave="clear()"
  >
    <img
      v-if="faviconUrl != undefined"
      :src="faviconUrl"
      class="favicon"
    >

    <span class="dont-break-out url-text">
      <transition name="url">
        <span
          v-if="hovered"
          key="1"
        >{{ urlParts[0] }}</span>
      </transition>

      <span
        key="2"
        class="domain"
      >{{ domain }}</span>

      <transition name="urlEnd">
        <span
          v-if="hovered"
          key="3"
        >{{ urlParts[1] }}</span>
      </transition>
    </span>
  </a>
</template>

<script>
  export default {
    name: 'BookmarkUrl',
    props: ['faviconUrl', 'url'],
    data: function() {
      return {
        selected: '',
        hovered: false
      }
    },
    computed: {
      domain() {
        let domain
        if (this.url.indexOf("://") > -1) {
          domain = this.url.split('/')[2]
        }
        else {
          domain = this.url.split('/')[0]
        }

        domain = domain.split(':')[0]

        if (domain.includes('www')) {
          domain = domain.split('www.')[1]
        }

        return domain
      },
      urlParts() {
        return this.url.split(this.domain)
      }
    },
    methods: {
      hover(url) {
          this.selected = url
          setTimeout(() => {
              if(this.selected === url )
                  this.hovered = true
              },
              300
          )
      },
      clear() {
        this.selected = ''
        this.hovered = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .favicon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: middle;

    float: left;
    margin-top: 0.2rem;
  }

  .url-text {
    overflow: hidden;
    display: inline-block;
    max-width: 94%;
    vertical-align: middle;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 10px;
    text-overflow: ellipsis;
    height: 1.1rem;
    word-break: break-all;

    span {
      // display: inline-block;
      // float:left;
      overflow:hidden;
      max-width: 1000px;
    }
  }

  .url-enter-active, .url-leave-active,
  .urlEnd-enter-active, .urlEnd-leave-active {
    transition: opacity 0.1s ease-out, margin-left 0.2s ease-out;
  }
  .url-enter, .url-leave-to {
    margin-left: -30px;
  }

  .urlEnd-enter, .urlEnd-leave-to {
    opacity: 0;
  }
</style>
